module.exports = require("fs-extra");


//////////////////
// WEBPACK FOOTER
// external "fs-extra"
// module id = 6
// module chunks = 0